import { render } from "./TitleMedium.vue?vue&type=template&id=f056fa7a&scoped=true"
const script = {}

import "./TitleMedium.vue?vue&type=style&index=0&id=f056fa7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f056fa7a"]])

export default __exports__